import { getDocumentBlobFromStorage } from 'modules/_shared/utils/getDocumentBlobFromStorage';

export const getDocumentFrame = async (documentId: string) => {
  const blob = await getDocumentBlobFromStorage(documentId);
  if (blob) {
    const url = URL.createObjectURL(blob);
    return url;
  }
};
